<template>
  <ProductListDiv>
    <!-- ! 카테고리, 안전재고 영역 -->
    <ProductListCategoryArea>
      <ProductListFlexContainer>
        <!-- * 의료기 카테고리 (왼쪽) -->
        <MainCategorySection>
          <MainCategoryHeader>
            <MainCategoryTitle>
              <span>의료기 카테고리</span>
            </MainCategoryTitle>
          </MainCategoryHeader>

          <!-- * 메인 카테고리 선택 탭 -->
          <MainCategoryTabs>
            <MainCategoryTab @click="selectMainCategoryTab('purchase')"
              :class="{ active: selectedMainTab === 'purchase' }">
              구매 및 대여
            </MainCategoryTab>
            <MainCategoryTab @click="selectMainCategoryTab('oxygen')" :class="{ active: selectedMainTab === 'oxygen' }">
              산소발생기
            </MainCategoryTab>
            <MainCategoryTab @click="selectMainCategoryTab('assist')" :class="{ active: selectedMainTab === 'assist' }">
              보조기기
            </MainCategoryTab>
          </MainCategoryTabs>

          <SubCategoryContent>
            <!-- * 구매 및 대여 카테고리 -->
            <CategorySection v-if="selectedMainTab === 'purchase'">
              <CategoryLabel>의료기 카테고리</CategoryLabel>
              <CategoryButtonContainer>
                <CategoryButton
                  v-for="cat1 in categoryTree.filter(cat => cat.name !== '호흡(석션용품)' && cat.name !== '보조기기')"
                  :key="cat1.num" @click="selectCategory(cat1)"
                  :class="{ active: selectedCategory1 && selectedCategory1.num === cat1.num }">
                  {{ cat1.name }}
                </CategoryButton>
              </CategoryButtonContainer>
            </CategorySection>

            <!-- * 재고위치 카테고리 -->
            <CategorySection v-if="selectedMainTab === 'purchase'">
              <CategoryLabel>재고위치</CategoryLabel>
              <CategoryButtonContainer>
                <LocationCategoryButton v-for="location in locationCategories" :key="location"
                  @click="selectLocationCategory(location)" :class="{ active: selectedLocationCategory === location }">
                  {{ location }}
                </LocationCategoryButton>
              </CategoryButtonContainer>
            </CategorySection>

            <!-- * 산소발생기 카테고리 -->
            <CategorySection v-if="selectedMainTab === 'oxygen'">
              <CategoryButtonContainer>
                <CategoryButton v-for="cat1 in categoryTree.filter(cat => cat.name === '호흡(석션용품)')" :key="cat1.num"
                  @click="selectCategory(cat1)"
                  :class="{ active: selectedCategory1 && selectedCategory1.num === cat1.num }">
                  {{ cat1.name }}
                </CategoryButton>
              </CategoryButtonContainer>
            </CategorySection>

            <!-- * 재고위치 카테고리 -->
            <CategorySection v-if="selectedMainTab === 'oxygen'">
              <CategoryLabel>재고위치</CategoryLabel>
              <CategoryButtonContainer>
                <LocationCategoryButton v-for="location in locationCategories" :key="location"
                  @click="selectLocationCategory(location)" :class="{ active: selectedLocationCategory === location }">
                  {{ location }}
                </LocationCategoryButton>
              </CategoryButtonContainer>
            </CategorySection>

            <!-- * 보조기기 카테고리 -->
            <CategorySection v-if="selectedMainTab === 'assist'">
              <CategoryButtonContainer>
                <CategoryButton v-for="subCat in getSubcategoriesForCategory('보조기기')" :key="'sub-' + subCat.num"
                  @click="selectSubcategory(subCat)"
                  :class="{ active: selectedSubCategory && selectedSubCategory.num === subCat.num }">
                  {{ subCat.name }}
                </CategoryButton>
              </CategoryButtonContainer>
            </CategorySection>

            <!-- * 재고위치 카테고리 -->
            <CategorySection v-if="selectedMainTab === 'assist'">
              <CategoryLabel>재고위치</CategoryLabel>
              <CategoryButtonContainer>
                <LocationCategoryButton v-for="location in locationCategories" :key="location"
                  @click="selectLocationCategory(location)" :class="{ active: selectedLocationCategory === location }">
                  {{ location }}
                </LocationCategoryButton>
              </CategoryButtonContainer>
            </CategorySection>
          </SubCategoryContent>
        </MainCategorySection>

        <!-- * 안전재고 영역 (오른쪽) -->
        <SafetyStockArea>
          <SafetyStockHeader>
            <SafetyStockLeftGroup>
              <SafetyStockInputContainer>
                <SafetyStockInput v-model="inputSafetyStock" placeholder="품목 검색 Enter"
                  @keyup.enter="searchSafetyStock" />
                <SearchIcon @click="filterSafetyStockBySearch">
                  <Magnify :size="18" />
                </SearchIcon>
              </SafetyStockInputContainer>
              <SafetyStockSelect v-model="selectedSafetyStock">
                <option value="00">전체</option>
                <option v-for="category in allCategories" :key="category.num" :value="category.name">
                  {{ category.name }}
                </option>
              </SafetyStockSelect>
            </SafetyStockLeftGroup>
            <SafetyStockCenterGroup>
              <SafetyStockTitle>안전재고</SafetyStockTitle>
              <SafetyStockCount v-if="safetyStockItems.length > 0">{{ safetyStockTotalItems }}</SafetyStockCount>
            </SafetyStockCenterGroup>

            <div style="flex: 1;"></div>
          </SafetyStockHeader>

          <SafetyStockTable>
            <thead>
              <tr>
                <SafetyStockTh width="20%">거래처명</SafetyStockTh>
                <SafetyStockTh width="45%">품목</SafetyStockTh>
                <SafetyStockTh width="10%">색상</SafetyStockTh>
                <SafetyStockTh width="10%">사이즈</SafetyStockTh>
                <SafetyStockTh width="10%">재고수량</SafetyStockTh>
                <SafetyStockTh width="20%">
                  <SafetyStockEditContainer>
                    안전재고수량
                    <SafetyStockEditButton @click="updateAllSafetyStock" title="클릭하면 모든 품목의 안전재고수량을 수정할 수 있습니다.">
                      <Pencil :size="16" :style="{ paddingTop: '2px' }" />
                    </SafetyStockEditButton>
                  </SafetyStockEditContainer>
                </SafetyStockTh>
                <SafetyStockTh width="15%">발주</SafetyStockTh>
              </tr>
            </thead>
            <tbody>
              <!-- 데이터가 있을 때 -->
              <template v-if="safetyStockItems.length > 0">
                <SafetyStockTr v-for="(item, index) in safetyStockItems" :key="index" @click="openDetailModal(item)"
                  style="cursor: pointer;">
                  <SafetyStockTd>
                    {{ item.company }}
                  </SafetyStockTd>
                  <SafetyStockTd>
                    {{ item.name }}
                  </SafetyStockTd>
                  <SafetyStockTd>
                    {{ item.color }}
                  </SafetyStockTd>
                  <SafetyStockTd>
                    {{ item.size }}
                  </SafetyStockTd>
                  <SafetyStockTd>
                    {{ item.quantity }}
                  </SafetyStockTd>
                  <SafetyStockTd @click.stop>
                    <SafetyStockEditContainer>
                      <span>{{ item.safety }}</span>
                      <SafetyStockEditButton @click="updateSafetyStock(item)" title="클릭하면 안전재고수량을 수정할 수 있습니다.">
                        <Pencil :size="16" :style="{ paddingTop: '2px' }" />
                      </SafetyStockEditButton>
                    </SafetyStockEditContainer>
                  </SafetyStockTd>
                  <SafetyStockTd @click.stop>
                    <OrderButton @click="showDevelopMessage">
                      발주신청
                    </OrderButton>
                  </SafetyStockTd>
                </SafetyStockTr>
              </template>

              <!-- 데이터가 없을 때 -->
              <tr v-if="!safetyStockLoading && safetyStockItems.length === 0">
                <SafetyStockTd colspan="100%" class="empty-message">
                  안전재고 항목이 없습니다.
                </SafetyStockTd>
              </tr>
            </tbody>
          </SafetyStockTable>

          <!-- 페이지네이션 -->
          <PaginationContainer v-if="safetyStockTotalPages > 1">
            <PageButton @click="changeSafetyStockPage(1)" :disabled="safetyStockCurrentPage === 1 || safetyStockLoading"
              :class="{ disabled: safetyStockCurrentPage === 1 || safetyStockLoading }">
              <ChevronDoubleLeft />
            </PageButton>

            <PageButton @click="changeSafetyStockPage(safetyStockCurrentPage - 1)"
              :disabled="safetyStockCurrentPage === 1 || safetyStockLoading"
              :class="{ disabled: safetyStockCurrentPage === 1 || safetyStockLoading }">
              <ChevronLeft />
            </PageButton>

            <PageButton v-for="page in displayedSafetyStockPages" :key="page" @click="changeSafetyStockPage(page)"
              :disabled="safetyStockLoading"
              :class="{ active: page === safetyStockCurrentPage, disabled: safetyStockLoading }">
              {{ page }}
            </PageButton>

            <PageButton @click="changeSafetyStockPage(safetyStockCurrentPage + 1)"
              :disabled="safetyStockCurrentPage === safetyStockTotalPages || safetyStockLoading"
              :class="{ disabled: safetyStockCurrentPage === safetyStockTotalPages || safetyStockLoading }">
              <ChevronRight />
            </PageButton>

            <PageButton @click="changeSafetyStockPage(safetyStockTotalPages)"
              :disabled="safetyStockCurrentPage === safetyStockTotalPages || safetyStockLoading"
              :class="{ disabled: safetyStockCurrentPage === safetyStockTotalPages || safetyStockLoading }">
              <ChevronDoubleRight />
            </PageButton>
          </PaginationContainer>
        </SafetyStockArea>
      </ProductListFlexContainer>
    </ProductListCategoryArea>

    <!-- ! 재고 목록 Header Area -->
    <ProductListTableArea>
      <ProductListHeaderBtnArea>
        <!-- * 왼쪽 그룹 -->
        <HeaderLeftGroup>
          <ProductListHeaderH2>재고 목록 (총 {{ totalItems }}개 항목)</ProductListHeaderH2>
          <ProductlistHeaderBtn @click="openNewModal">신규 품목 등록</ProductlistHeaderBtn>
          <ProductlistHeaderBtn @click="openQRCodeModal">가격표 생성</ProductlistHeaderBtn>
        </HeaderLeftGroup>

        <!-- * 중앙 그룹 -->
        <HeaderCenterGroup>
          <ProductListSearchInput v-model="searchQuery" placeholder="품목 검색 (품목명 또는 해시태그)"
            @keyup.enter="searchProducts" />
          <ProductSearchBtn @click="searchProducts">
            <Magnify />
          </ProductSearchBtn>
        </HeaderCenterGroup>

        <!-- * 오른쪽 그룹 -->
        <HeaderRightGroup>
          <ProductlistHeaderBtn @click="showModal_obj.excel_upload = true">엑셀 재고등록</ProductlistHeaderBtn>
          <ProductlistHeaderBtn @click="openLocationAddModal">재고위치 등록</ProductlistHeaderBtn>
          <ProductlistHeaderBtn @click="openLocationPrintModal">재고위치 인쇄</ProductlistHeaderBtn>
          <BarcodeDisplayArea @click="startBarcodeScanning" :class="{ active: isBarcodeScanning }">
            {{ isBarcodeScanning ? '스캔 중지' : '바코드 스캔' }}
          </BarcodeDisplayArea>
        </HeaderRightGroup>
      </ProductListHeaderBtnArea>

      <!-- !재고 목록 Table Area -->
      <ProductListTable v-if="groupedInventory.length > 0">
        <thead>
          <ProductListTr>
            <ProductListTh>카테고리</ProductListTh>
            <ProductListTh>이미지</ProductListTh>
            <ProductListTh>품목명</ProductListTh>
            <ProductListTh>모델명</ProductListTh>
            <ProductListTh>코드</ProductListTh>
            <ProductListTh>대상</ProductListTh>
            <ProductListTh>바코드</ProductListTh>
            <ProductListTh>가격</ProductListTh>
            <ProductListTh>색상</ProductListTh>
            <ProductListTh>사이즈</ProductListTh>
            <ProductListTh>보유재고</ProductListTh>
            <ProductListTh>비고</ProductListTh>
          </ProductListTr>
        </thead>
        <tbody>
          <template v-for="group in groupedInventory" :key="group.name">
            <ProductListTr v-for="(item, index) in group.items" :key="item.num" @click="openDetailModal(item)">
              <ProductListTd v-if="index === 0" :rowspan="group.items.length">{{ group.name0 }}</ProductListTd>
              <ProductListTd v-if="index === 0" :rowspan="group.items.length">
                <img :src="getImageUrl(group.items[0])" :alt="group.name3" :key="imageUpdateKey"
                  :data-item="JSON.stringify(group.items[0])" style="width: 80px; height: auto;"
                  @error="handleImageError" />
              </ProductListTd>
              <ProductListTd v-if="index === 0" :rowspan="group.items.length">{{ group.name3 }}</ProductListTd>
              <ProductListTd v-if="index === 0" :rowspan="group.items.length">{{ group.name4 }}</ProductListTd>
              <ProductListTd>
                <StandardBadge v-if="item.code && item.code.trim() !== ''">{{ item.code }}</StandardBadge>
                <span v-else style="color: #9ca3af;">-</span>
              </ProductListTd>
              <ProductListTd>{{ group.target }}</ProductListTd>
              <ProductListTd>
                <StandardBadge v-if="item.bcode && item.bcode.trim() !== ''">{{ item.bcode }}</StandardBadge>
                <span v-else style="color: #9ca3af;">-</span>
              </ProductListTd>
              <PriceCell style="color: #ea580c;">{{ item.price }}</PriceCell>
              <ProductListTd>
                <StandardBadge v-if="item.color && item.color.trim() !== ''">{{ item.color }}</StandardBadge>
                <span v-else style="color: #9ca3af;">-</span>
              </ProductListTd>
              <ProductListTd>
                <StandardBadge v-if="item.size && item.size.trim() !== ''">{{ item.size }}</StandardBadge>
                <span v-else style="color: #9ca3af;">-</span>
              </ProductListTd>
              <ProductListTd>
                <StockBadge>{{ getTotalQuantity(item.quantity, item.piece_quantity) }}</StockBadge>
              </ProductListTd>
              <NoteCell>{{ item.note }}</NoteCell>
            </ProductListTr>
          </template>
        </tbody>
      </ProductListTable>

      <!-- !페이지네이션 -->
      <ProductListPageArea class="pagination" v-if="groupedInventory.length > 0">
        <ProductListBtn @click="goToPage(1)" :disabled="currentPage === 1">
          <BtnContent>
            <ChevronDoubleLeft :size="20" />
          </BtnContent>
        </ProductListBtn>
        <ProductListBtn @click="goToPage(currentPage - 1)" :disabled="currentPage === 1">
          <BtnContent>
            <ChevronLeft :size="20" />
          </BtnContent>
        </ProductListBtn>
        <ProductListBtn v-for="page in visiblePages" :key="page" @click="goToPage(page)"
          :class="{ 'current-page': page === currentPage }">
          {{ page }}
        </ProductListBtn>
        <ProductListBtn @click="goToPage(currentPage + 1)" :disabled="currentPage === totalPages">
          <BtnContent>
            <ChevronRight :size="20" />
          </BtnContent>
        </ProductListBtn>
        <ProductListBtn @click="goToPage(totalPages)" :disabled="currentPage === totalPages">
          <BtnContent>
            <ChevronDoubleRight :size="20" />
          </BtnContent>
        </ProductListBtn>
      </ProductListPageArea>
    </ProductListTableArea>

    <!-- ! 안전재고 알림 모달 -->
    <ModalPage v-model:show="showAlertModal" :height="'730px'" :width="'600px'">
      <AlertModal :show="showAlertModal" :type="alertModalType" :title="alertModalTitle"
        :safetyStockItems="safetyStockItems" @close="closeAlertModal" />
    </ModalPage>

    <!-- ! 상세보기 모달 -->
    <ModalPage v-model:show="showModal_obj.product_detail" :width="modal_width.product_detail"
      :height="modal_height.product_detail">
      <ProductListDetail :Item="selectedItem" @productDeleted="handleProductDeleted" @itemUpdated="handleItemUpdated"
        @closeModal="closeDetailModal" />
    </ModalPage>

    <!-- ! 신규 품목 등록 모달 -->
    <ModalPage v-model:show="showModal_obj.product_new" :width="modal_width.product_new"
      :height="modal_height.product_new">
      <ProductAddNew @productAdded="fetchInventory" @closeModal="showModal_obj.product_new = false" />
    </ModalPage>

    <!-- ! 엑셀 재고등록 모달 -->
    <ModalPage v-model:show="showModal_obj.excel_upload" :width="modal_width.excel_upload"
      :height="modal_height.excel_upload">
      <ExcelUploadDiv>
        <ExcelUploadTitle>엑셀 재고등록</ExcelUploadTitle>
        <ExcelUploadSubTitle>* 재고 템플릿을 다운받아 입력 후 엑셀 파일을 업로드 해주세요.</ExcelUploadSubTitle>
        <ExcelUploadBtnArea>
          <ExcelUploadBtn @click="downloadExcelTemplate">
            재고 템플릿 다운로드
          </ExcelUploadBtn>
          <ExcelUploadBtn @click="$refs.excelFileInput.click()">
            재고 엑셀 파일 업로드
            <input type="file" ref="excelFileInput" accept=".xlsx" style="display: none" @change="handleExcelUpload" />
          </ExcelUploadBtn>
        </ExcelUploadBtnArea>
      </ExcelUploadDiv>
    </ModalPage>

    <QRCodePrintList v-if="showQRCodeModal" :inventory="inventory" @close="closeQRCodeModal" />
    <LocationPrint v-if="showLocationPrintModal" :inventory="inventory" @close="closeLocationPrintModal" />
    <LocationAddModal v-if="showLocationAddModal" :targetLocation="targetLocationForModal"
      :initialBarcode="initialBarcodeForModal" @close="closeLocationAddModal" @productRegistered="onProductRegistered"
      @productsSaved="onProductsSaved" />
  </ProductListDiv>
</template>

<script>
import { ref, reactive } from 'vue';

import ModalPage from '@/components/layout/ModalPage.vue';
import ProductListDetail from '@/components/product/ProductDetail.vue';
import ProductAddNew from '@/components/product/modal/ProductAddModal.vue';
import QRCodePrintList from '@/components/product/modal/QRprintModal.vue';
import LocationPrint from '@/components/product/modal/LocationPrint.vue';
import AlertModal from '@/components/layout/AlertModal.vue';
import LocationAddModal from '@/components/product/modal/LocationAddModal.vue';

import * as ProductListCss from '@/assets/styles/product/ProductListCss.js'

import Magnify from 'vue-material-design-icons/Magnify.vue';
import ChevronDoubleLeft from 'vue-material-design-icons/ChevronDoubleLeft.vue';
import ChevronDoubleRight from 'vue-material-design-icons/ChevronDoubleRight.vue';
import ChevronLeft from 'vue-material-design-icons/ChevronLeft.vue';
import ChevronRight from 'vue-material-design-icons/ChevronRight.vue';
import Pencil from 'vue-material-design-icons/Pencil.vue';

export default {
  name: 'ProductList',

  components: {
    QRCodePrintList,
    LocationPrint,
    ...ProductListCss,
    ModalPage,
    ProductListDetail,
    ProductAddNew,
    AlertModal,
    LocationAddModal,
    Magnify, ChevronDoubleLeft, ChevronDoubleRight, ChevronLeft, ChevronRight, Pencil
  },

  setup() {
    const showModal_obj = reactive({
      product_detail: ref(false),
      product_new: ref(false),
      excel_upload: ref(false)
    });
    const modal_width = {
      product_detail: '80%',
      product_new: '70%',
      excel_upload: '550px'
    };
    const modal_height = {
      product_detail: '80%',
      product_new: '80%',
      excel_upload: '230px'
    };
    return {
      showModal_obj,
      modal_width,
      modal_height,
    }
  },
  data() {
    return {
      inventory: ref([]),
      searchQuery: '',
      showModal: false,
      showAddModal: false,
      selectedItem: null,
      imageUpdateKey: Date.now(),
      selectedMainTab: 'purchase',
      newProduct: {
        name: '',
        name2: '',
        size: '',
        color: '',
        option: '',
        target: '',
        bcode: '',
        code: '',
        price: '',
        quantity: '',
        piece_quantity: '',
        all_quantity: '',
        note: '',
        company: '',
        tax: ''
      },
      selectedCategory: '',
      selectedStatus: '',
      categoryTree: [],
      selectedCategory1: null, // 카테고리 1
      selectedSubCategory: null, // 하위 카테고리
      selectedLocationCategory: '', // 선택된 재고위치
      targetLocationForModal: '', // 모달에 전달할 재고위치
      initialBarcodeForModal: '', // 모달에 전달할 바코드 정보
      locationCategories: [], // 재고위치 목록
      categoryType: '',
      selectedSection: '',
      qrCodeUrl: null,
      showQRCodeModal: false,
      showLocationPrintModal: false,
      showLocationAddModal: false,
      locationAddModalLocation: '',
      currentPage: 1,
      totalPages: 1,
      totalItems: 0,
      pnStart: 1,
      pnEnd: 1,
      // 안전재고 관련 데이터
      allSafetyStockItems: [], // 전체 안전재고 아이템
      filteredSafetyStockItems: [], // 카테고리로 필터링된 안전재고 아이템
      safetyStockItems: [], // 현재 페이지에 표시할 안전재고 아이템
      allCategories: [],
      maxQuantity: 3, // 안전재고 기준 수량
      safetyStockCurrentPage: 1,
      safetyStockItemsPerPage: 6,
      safetyStockTotalPages: 1,
      safetyStockTotalItems: 0,
      safetyStockLoading: false,
      selectedSafetyStock: '00',
      inputSafetyStock: '',
      // 알림 모달 관련
      showAlertModal: false,
      alertModalType: 'inventory',
      alertModalTitle: '안전재고 관리',
      // 바코드 스캔 관련
      isBarcodeScanning: false, // 바코드 스캔 상태
      barcodeBuffer: '', // 바코드 입력 버퍼
      lastKeyTime: 0, // 마지막 키 입력 시간
      barcodeTimeout: null, // 바코드 타임아웃
      scanStartTime: 0, // 스캔 시작 시간
      keyCount: 0, // 입력된 키 개수
      currentScannedLocation: null, // 현재 스캔된 위치 (재고가 없는 위치)
    };
  },

  computed: {
    displayedSafetyStockPages() {
      const currentGroup = Math.floor((this.safetyStockCurrentPage - 1) / 10);
      const startPage = currentGroup * 10 + 1;
      const endPage = Math.min(startPage + 9, this.safetyStockTotalPages);

      const pages = [];
      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }

      return pages;
    },

    // 페이지 계산
    visiblePages() {
      let start = Math.floor((this.currentPage - 1) / 10) * 10 + 1;
      let end = Math.min(start + 9, this.totalPages);
      return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    },
    // 품목 그룹화
    groupedInventory() {
      const groups = {};

      this.filteredInventory.forEach(item => {
        if (!item.name3) return;

        const key = `${item.name3}-${item.target}-${item.code}`;

        if (!groups[key]) {
          groups[key] = {
            key,
            name0: item.category || item.name0,    // 카테고리
            name3: item.name3,    // 품목명
            name4: item.name4,    // 모델명
            target: item.target,  // 대상
            code: item.code,      // 코드
            items: [],            // 세부 아이템 배열
          };
        }

        // 개별 아이템에 나머지 속성들 포함
        groups[key].items.push({
          ...item,
          bcode: item.options?.bcode?.[0] || '',  // 바코드 (options에서 가져옴)
          status: item.status || '',              // 상태
          icode: item.icode || '',                // 보험코드
          price: item.price ? item.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0',  // 가격
          note: item.options?.note?.[0] || '',    // 비고 (options에서 가져옴)
          color: item.options?.color?.[0] || '',  // 색상 (options에서 가져옴)
          size: item.options?.size?.[0] || '',    // 사이즈 (options에서 가져옴)
          quantity: item.quantity || '0',          // 수량
          piece_quantity: item.piece_quantity || '0', // 낱개수량
          all_quantity: item.all_quantity || '0' // 합계수량
        });
      });

      // 각 그룹 내의 아이템들을 사이즈 순으로 정렬
      Object.values(groups).forEach(group => {
        group.items.sort((a, b) => {
          const getSizeOrder = (size) => {
            if (!size) return 1000;

            const upperSize = size.toUpperCase();
            if (upperSize === 'S' || upperSize === 'SS') return 1;
            if (upperSize === 'M') return 2;
            if (upperSize === 'L') return 3;
            if (upperSize === 'XL') return 4;
            if (upperSize === 'XXL' || upperSize === '2XL') return 5;
            if (upperSize === 'XXXL' || upperSize === '3XL') return 6;

            // 한글 사이즈
            if (size === '소') return 11;
            if (size === '중') return 12;
            if (size === '대') return 13;
            if (size === '중대형') return 14;
            if (size === '대형') return 15;
            if (size === '특대') return 16;
            if (size === '특대형') return 17;

            // 숫자 사이즈
            const numMatch = size.match(/^(\d+)/);
            if (numMatch) {
              return 100 + parseInt(numMatch[1]);
            }

            return 999;
          };

          return getSizeOrder(a.size) - getSizeOrder(b.size);
        });
      });

      return Object.values(groups);
    },

    filteredInventory() {
      let filtered = this.inventory.filter(item => item.name3 && item.name3.trim() !== '');

      // 재고위치 필터 적용
      if (this.selectedLocationCategory) {
        filtered = filtered.filter(item => {
          const itemLocation = item.location || '';
          return itemLocation === this.selectedLocationCategory;
        });
      }

      return filtered;
    },

    totalSafetyStockPages() {
      return Math.ceil(this.safetyStockItems.length / this.itemsPerPage);
    },

    // 현재 페이지에 표시할 안전재고 아이템
    paginatedSafetyStockItems() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.safetyStockItems.slice(start, end);
    }
  },

  methods: {
    getTotalQuantity(quantity, pieceQuantity) {
      const q = Number(quantity) || 0;
      const p = Number(pieceQuantity) || 0;

      let result;
      if (q === 0 && p === 0) {
        result = 0;
      } else if (q === 0) {
        result = p;
      } else if (p === 0) {
        result = q;
      } else {
        result = q * p;
      }
      return result;
    },

    // 품목 등록 완료 처리
    async onProductRegistered(data) {
      try {
        // 등록된 품목의 위치로 자동 필터링
        if (data.targetLocation && data.targetLocation !== '없음') {
          // 재고위치 카테고리를 등록된 위치로 설정
          this.selectedLocationCategory = data.targetLocation;
        }

        // 재고 목록 새로고침
        await this.fetchInventory();

      } catch (error) {
        console.error('품목 등록 처리 중 오류:', error);
      }
    },

    // 기존 품목 저장 완료 처리
    async onProductsSaved(data) {
      try {
        // 저장된 품목들의 위치로 자동 필터링
        if (data.targetLocation && data.targetLocation !== '없음') {
          this.selectedLocationCategory = data.targetLocation;
        }

        // 재고 목록 새로고침
        await this.fetchInventory();

      } catch (error) {
        console.error('품목 저장 처리 중 오류:', error);
      }
    },

    // 바코드 스캔 시작
    startBarcodeScanning() {
      if (this.isBarcodeScanning) {
        this.stopBarcodeScanning();
      } else {
        this.isBarcodeScanning = true;
        this.barcodeBuffer = '';
        this.scanStartTime = 0;
        this.keyCount = 0;

        // 키보드 이벤트 리스너 추가
        document.addEventListener('keydown', this.handleScan, true); // capture 단계에서 처리

        // 마우스 클릭 이벤트 차단
        document.addEventListener('mousedown', this.blockMouseEvents, true);
        document.addEventListener('mouseup', this.blockMouseEvents, true);
      }
    },

    // 바코드 스캔 중지
    stopBarcodeScanning() {
      this.isBarcodeScanning = false;
      this.barcodeBuffer = '';
      this.scanStartTime = 0;
      this.keyCount = 0;

      // 키보드 이벤트 리스너 제거
      document.removeEventListener('keydown', this.handleScan, true);

      // 마우스 이벤트 리스너 제거
      document.removeEventListener('mousedown', this.blockMouseEvents, true);
      document.removeEventListener('mouseup', this.blockMouseEvents, true);

      if (this.barcodeTimeout) {
        clearTimeout(this.barcodeTimeout);
        this.barcodeTimeout = null;
      }
    },

    blockMouseEvents(event) {
      if (this.isBarcodeScanning) {
        // 바코드 스캔 버튼 클릭은 허용
        const target = event.target;
        const barcodeButton = target.closest('[class*="BarcodeDisplayArea"]');

        if (!barcodeButton) {
          event.preventDefault();
          event.stopPropagation();
        }
      }
    },

    // 바코드 입력 처리
    handleScan(event) {
      if (!this.isBarcodeScanning) return;

      const keyCode = event.keyCode || event.which;

      // 텍스트 선택 관련 키는 허용 (Ctrl+A, Ctrl+C 등)
      if (event.ctrlKey || event.metaKey) {
        return; // 복사, 붙여넣기, 전체선택 등 허용
      }

      // 텍스트 선택을 위한 키들 허용
      const allowedKeys = [16, 17, 18, 37, 38, 39, 40, 91, 93]; // Shift, Ctrl, Alt, 화살표키, Cmd
      if (allowedKeys.includes(keyCode)) {
        return;
      }

      // 입력 필드에 포커스가 있는 경우 바코드 스캔 무시
      const activeElement = document.activeElement;
      if (activeElement && (
        activeElement.tagName === 'INPUT' ||
        activeElement.tagName === 'TEXTAREA' ||
        activeElement.tagName === 'SELECT' ||
        activeElement.contentEditable === 'true'
      )) {
        return;
      }

      const currentTime = Date.now();

      // Enter 키가 눌렸을 때 (바코드 스캔 완료)
      if (event.key === 'Enter') {
        event.preventDefault();
        event.stopPropagation();

        if (this.barcodeBuffer.trim()) {

          // 바코드 스캐너 특성 검증
          if (this.validateBarcodeScanner()) {
            this.processBarcodeData(this.barcodeBuffer.trim());
          }

          this.barcodeBuffer = '';
          this.scanStartTime = 0;
          this.keyCount = 0;
        }
        return;
      }

      // 일반 문자 입력
      if (event.key.length === 1) {
        event.preventDefault();
        event.stopPropagation();

        // 첫 번째 문자인 경우 스캔 시작 시간 기록
        if (this.barcodeBuffer === '') {
          this.scanStartTime = currentTime;
          this.keyCount = 0;
        }

        // 바코드 스캐너는 매우 빠르게 입력하므로 시간 간격으로 구분
        if (currentTime - this.lastKeyTime > 100) {
          this.barcodeBuffer = event.key;
          this.scanStartTime = currentTime;
          this.keyCount = 1;
        } else {
          this.barcodeBuffer += event.key;
          this.keyCount++;
        }

        this.lastKeyTime = currentTime;

        // 타임아웃 설정 (바코드 입력 완료 대기)
        if (this.barcodeTimeout) {
          clearTimeout(this.barcodeTimeout);
        }

        this.barcodeTimeout = setTimeout(() => {
          if (this.barcodeBuffer.trim()) {

            // 바코드 스캐너 특성 검증
            if (this.validateBarcodeScanner()) {
              this.processBarcodeData(this.barcodeBuffer.trim());
            }

            this.barcodeBuffer = '';
            this.scanStartTime = 0;
            this.keyCount = 0;
          }
        }, 200);
      }
    },

    // 바코드 스캐너 특성 검증
    validateBarcodeScanner() {
      if (!this.scanStartTime || this.keyCount === 0) {
        return false;
      }

      const totalTime = Date.now() - this.scanStartTime;
      const avgTimePerChar = totalTime / this.keyCount;
      const charsPerSecond = 1000 / avgTimePerChar;

      return (
        charsPerSecond >= 5 &&
        this.barcodeBuffer.length >= 8 &&
        avgTimePerChar <= 50
      );
    },

    // 바코드/QR 코드 데이터 처리
    async processBarcodeData(scannedData) {
      try {
        let qrData;

        // 먼저 Base64 디코딩 시도
        try {
          const decodedData = decodeURIComponent(escape(atob(scannedData)));
          qrData = JSON.parse(decodedData);
        } catch (base64Error) {
          // Base64 디코딩 실패 시 직접 JSON 파싱 시도
          qrData = JSON.parse(scannedData);
        }

        // 재고위치 QR 코드 처리
        if (qrData.location) {
          const hasInventory = await this.filterByLocation(qrData.location);

          // 재고가 있을 때만 스캔 완료 메시지 표시
          if (hasInventory) {
            this.$swal.fire({
              title: '재고위치 QR 스캔 완료',
              html: `
                        <p><strong>위치:</strong> ${qrData.location}</p>
                        <p>해당 위치의 모든 품목을 표시합니다.</p>
                      `,
              icon: 'success',
              timer: 1000,
              showConfirmButton: false
            });
          }
          return;
        }

        // 품목 QR 코드 처리
        if (qrData.type === 'PRODUCT_QR' && qrData.Barcode && qrData.ProductName) {
          const location = qrData.Location || '';
          const hasInventory = await this.filterByLocation(location);

          // 재고가 있을 때만 스캔 완료 메시지 표시
          if (hasInventory) {
            this.$swal.fire({
              title: '품목 QR 스캔 완료',
              html: `
                        <p><strong>품목명:</strong> ${qrData.ProductName}</p>
                        <p><strong>바코드:</strong> ${qrData.Barcode}</p>
                        <p><strong>위치:</strong> ${location || '미지정'}</p>
                        <p>해당 위치의 모든 품목을 표시합니다.</p>
                      `,
              icon: 'success',
              timer: 1000,
              showConfirmButton: false
            });
          }
          return;
        }

        // 기존 제품 QR 코드 처리
        if (qrData.Barcode && qrData.ProductName && qrData.Location !== undefined) {
          const location = qrData.Location;
          const hasInventory = await this.filterByLocation(location);

          // 재고가 있을 때만 스캔 완료 메시지 표시
          if (hasInventory) {
            this.$swal.fire({
              title: 'QR 코드 스캔 완료',
              html: `
                        <p><strong>품목명:</strong> ${qrData.ProductName}</p>
                        <p><strong>바코드:</strong> ${qrData.Barcode}</p>
                        <p><strong>위치:</strong> ${location || '미지정'}</p>
                        <p>해당 위치의 모든 품목을 표시합니다.</p>
                      `,
              icon: 'success',
              timer: 1000,
              showConfirmButton: false
            });
          }
          return;
        }
      } catch (error) {
        console.error('QR 코드 파싱 오류:', error);
      }

      // 일반 바코드인 경우 - 해당 바코드의 제품을 찾아서 Location 추출
      this.findProductByBarcodeAndFilter(scannedData);
    },

    // 바코드로 품목 찾기
    async findProductByBarcodeAndFilter(barcode) {
      try {
        // 현재 inventory에서 해당 바코드를 가진 제품 찾기
        const foundProduct = this.inventory.find(item => {
          const itemBcode = item.options?.bcode?.[0] || item.bcode || '';
          return itemBcode === barcode;
        });

        if (foundProduct) {
          // 현재 스캔된 위치가 있고 해당 위치에 재고가 없는 경우
          if (this.currentScannedLocation && this.currentScannedLocation.trim() !== '') {
            await this.registerProductToLocation(foundProduct, barcode, this.currentScannedLocation);
            return;
          }

          // 일반적인 경우: 제품의 위치로 필터링
          const location = foundProduct.location || '';

          this.$swal.fire({
            title: '바코드 스캔 완료',
            html: `
              <p><strong>품목명:</strong> ${foundProduct.name3}</p>
              <p><strong>바코드:</strong> ${barcode}</p>
              <p><strong>위치:</strong> ${location || '미지정'}</p>
              <p>해당 위치의 모든 품목을 표시합니다.</p>
            `,
            icon: 'success',
            timer: 1000,
            showConfirmButton: false
          });

          // Location으로 필터링
          await this.filterByLocation(location);
        } else {
          // 현재 목록에 없는 경우 API로 검색
          await this.searchProductByBarcodeAPI(barcode);
        }
      } catch (error) {
        console.error('바코드 처리 중 오류:', error);
        this.$swal.fire({
          title: '오류',
          text: '바코드 처리 중 오류가 발생했습니다.',
          icon: 'error',
          confirmButtonText: '확인',
          confirmButtonColor: '#0f4c5c'
        });
      }
    },

    // 바코드 검색
    async searchProductByBarcodeAPI(barcode) {
      try {
        const response = await this.$axios.post(`${this.$apiUrls.hanqmedi}/searchProductByBarcode`, {
          barcode: barcode,
          companykey: this.$globalState.company_key
        });

        // 응답이 성공적이고 제품이 발견된 경우
        if (response.data && response.data.success && response.data.found && response.data.product) {
          const product = response.data.product;

          // 현재 스캔된 위치가 있고 해당 위치에 재고가 없는 경우
          if (this.currentScannedLocation && this.currentScannedLocation.trim() !== '') {
            await this.registerProductToLocation(product, barcode, this.currentScannedLocation);
            return;
          }

          // 일반적인 경우: 제품의 위치로 필터링
          const location = product.location || '';

          this.$swal.fire({
            title: '바코드 스캔 완료',
            html: `
              <p><strong>품목명:</strong> ${product.name3}</p>
              <p><strong>바코드:</strong> ${barcode}</p>
              <p><strong>위치:</strong> ${location || '미지정'}</p>
              <p>해당 위치의 모든 품목을 표시합니다.</p>
            `,
            icon: 'success',
            timer: 1000,
            showConfirmButton: false
          });

          // Location으로 필터링
          await this.filterByLocation(location);
        } else {
          // 바코드에 해당하는 제품을 찾을 수 없는 경우 수기 등록 안내
          this.$swal.fire({
            title: '품목을 찾을 수 없음',
            html: `
              <p><strong>스캔된 바코드:</strong> ${barcode}</p>
              <p>해당 바코드에 대한 품목 정보를 찾을 수 없습니다.</p>
              <div style="padding: 10px; background-color: #f8f9fa; border-radius: 8px;">
                <p style="color: #0f4c5c; font-weight: 600;">💡 해결 방법</p>
                <p style="font-size: 14px;">
                  새로운 품목이라면 '수기 등록'을 통해<br>
                  직접 품목 정보를 입력하실 수 있습니다.
                </p>
              </div>
            `,
            icon: 'info',
            showCancelButton: true,
            confirmButtonText: '수기 등록',
            cancelButtonText: '확인',
            confirmButtonColor: '#0f4c5c',
            cancelButtonColor: '#6c757d'
          }).then((result) => {
            if (result.isConfirmed) {
              const targetLocation = this.currentScannedLocation || '';
              this.openLocationAddModal(targetLocation, barcode);
            }
          });
        }
      } catch (error) {
        // 실제 네트워크 에러나 서버 에러만 여기서 처리
        console.error('바코드 검색 중 네트워크 오류:', error);

        this.$swal.fire({
          title: '네트워크 오류',
          text: '서버와의 연결에 문제가 발생했습니다. 잠시 후 다시 시도해주세요.',
          icon: 'error',
          confirmButtonText: '확인'
        });
      }
    },

    // 제품을 특정 위치에 등록
    async registerProductToLocation(product, barcode, location) {
      try {
        // 사용자에게 확인 요청
        const result = await this.$swal.fire({
          title: '위치 등록 확인',
          html: `
            <p><strong>품목명:</strong> ${product.name3}</p>
            <p><strong>바코드:</strong> ${barcode}</p>
            <p><strong>등록할 위치:</strong> ${location}</p>
            <br>
            <p style="color: #0f4c5c; font-weight: 600;">이 품목을 해당 위치에 등록하시겠습니까?</p>
          `,
          icon: 'question',
          showCancelButton: true,
          confirmButtonText: '등록',
          cancelButtonText: '취소',
          confirmButtonColor: '#0f4c5c',
          cancelButtonColor: '#6c757d'
        });

        if (result.isConfirmed) {

          // API 호출하여 제품 위치 업데이트
          const updateResponse = await this.$axios.post(`${this.$apiUrls.hanqmedi}/updateProductLocation`, {
            productId: product.num || product.id,
            barcode: barcode,
            location: location,
            companykey: this.$globalState.company_key
          });

          if (updateResponse.data && updateResponse.data.success) {

            this.$swal.fire({
              title: '위치 등록 완료',
              html: `
                  <p><strong>품목명:</strong> ${product.name3}</p>
                  <p><strong>바코드:</strong> ${barcode}</p>
                  <p><strong>등록된 위치:</strong> ${location}</p>
                  <p style="color: #0f4c5c; font-weight: 600;">성공적으로 등록되었습니다!</p>
                `,
              icon: 'success',
              showConfirmButton: true,
              confirmButtonText: '확인',
            });

            // 현재 스캔된 위치 초기화
            this.currentScannedLocation = null;

            // 데이터 새로고침
            await this.fetchInventory();

          } else {
            this.$swal.fire({
              title: '등록 실패',
              text: updateResponse.data?.message || '위치 등록 중 오류가 발생했습니다.',
              icon: 'error',
              confirmButtonText: '확인'
            });
          }
        }
      } catch (error) {
        console.error('위치 등록 중 오류:', error);

        const errorMessage = error.response?.data?.message || '위치 등록 중 오류가 발생했습니다.';

        this.$swal.fire({
          title: '등록 오류',
          text: errorMessage,
          icon: 'error',
          confirmButtonText: '확인'
        });
      }
    },

    // 재고 위치 필터
    async filterByLocation(location) {
      this.selectedMainTab = 'purchase';

      this.selectedCategory1 = null;
      this.selectedSubCategory = null;
      this.selectedCategory = '';
      this.selectedLocationCategory = location;

      this.currentPage = 1;
      await this.fetchInventory();

      // 해당 위치에 재고가 있는지 확인
      const hasInventoryInLocation = this.filteredInventory.length > 0;

      if (!hasInventoryInLocation && location && location.trim() !== '') {
        this.$swal.fire({
          title: '재고 없음',
          html: `
            <p><strong>위치:</strong> ${location}</p>
            <p>해당 위치에 등록된 재고가 없습니다.</p>
            <div style="padding-top: 1px; padding-bottom: 10px; background-color: #f8f9fa; border-radius: 5px;">
              <p style="color: #0f4c5c; font-weight: 600; margin-bottom: 8px;">📱 바코드가 있는 품목:</p>
              <p style="margin: 0; font-size: 14px;">품목 바코드를 스캔하면 이 위치에 자동으로 등록됩니다.</p>
            </div>
            <div style="padding-top: 1px; padding-bottom: 10px; background-color: #fff3cd; border-radius: 5px;">
              <p style="color: #856404; font-weight: 600; margin-bottom: 8px;">✏️ 바코드가 없는 품목:</p>
              <p style="margin: 0; font-size: 14px;">아래 '수기 등록' 버튼을 클릭하여 직접 입력하세요.</p>
            </div>
          `,
          icon: 'info',
          showCancelButton: true,
          confirmButtonText: '수기 등록',
          cancelButtonText: '확인',
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#6c757d'
        }).then((result) => {
          if (result.isConfirmed) {
            // LocationAdd 모달 열기
            this.openLocationAddModal(location);
          }
        });

        // 현재 스캔된 위치를 저장 (품목 등록용)
        this.currentScannedLocation = location;
      } else {
        // 재고가 있는 경우 현재 위치 초기화
        this.currentScannedLocation = null;
      }

      this.saveState();

      // 재고 존재 여부 반환
      return hasInventoryInLocation;
    },

    processScannedProduct(product) {
      this.selectedProduct = {
        num: product.num,
        name3: product.name3,
        name4: product.name4,
        code: product.code,
        bcode: product.bcode,
        price: product.price,
        company: product.company,
        location: product.location,
        status: product.status,
        icode: product.icode,
        note: product.note,
        color: product.color,
        size: product.size,
        quantity: product.quantity
      };

      this.$swal.fire({
        title: '제품 정보 로드 완료',
        text: `${product.name3} 정보가 로드되었습니다.`,
        icon: 'success',
        timer: 1500,
        showConfirmButton: false
      });
    },

    // 메인 카테고리 탭 선택
    selectMainCategoryTab(tabName) {
      this.selectedMainTab = tabName;

      // 탭 변경 시 선택된 카테고리 초기화
      this.selectedCategory1 = null;
      this.selectedSubCategory = null;
      this.selectedCategory = '';
      this.selectedLocationCategory = '';

      // 탭 변경 후 데이터 새로고침
      this.currentPage = 1;
      this.fetchInventory();
      this.saveState();
    },
    // =====================================
    // 카테고리 선택
    // =====================================
    selectCategory(cat1) {
      if (this.selectedCategory1 && this.selectedCategory1.num === cat1.num) {
        this.selectedCategory1 = null;
        this.selectedCategory = '';
        this.selectedSubCategory = null;
      } else {
        // 새로운 카테고리 선택
        this.selectedCategory1 = cat1;
        this.selectedCategory = cat1.name;
        this.selectedSubCategory = null;
      }

      this.currentPage = 1;
      this.fetchInventory();
      this.saveState();
    },

    // 재고위치 카테고리 선택
    selectLocationCategory(location) {
      // 이미 선택된 재고위치를 다시 클릭하면 해제
      if (this.selectedLocationCategory === location) {
        this.selectedLocationCategory = '';
      } else {
        // 새로운 재고위치 선택
        this.selectedLocationCategory = location;
      }

      this.currentPage = 1;
      this.fetchInventory();
      this.saveState();
    },

    // 재고위치 카테고리 추출
    async extractLocationCategories() {
      try {
        // 백엔드 API를 호출하여 모든 재고위치 가져오기
        const response = await this.$axios.get(`${this.$apiUrls.hanqmedi}/getAllLocations`, {
          params: {
            companykey: this.$globalState.company_key
          }
        });

        if (response.data && response.data.success) {
          // API에서 받은 위치 목록 사용
          const locations = response.data.data;

          // 정렬 로직 적용
          this.locationCategories = locations.sort((a, b) => {
            // 한글-숫자 형태의 문자열을 분리하여 정렬
            const parseLocation = (location) => {
              const match = location.match(/^([가-힣]+)-?(\d+)$/);
              if (match) {
                return {
                  korean: match[1],
                  number: parseInt(match[2], 10)
                };
              }
              // 매치되지 않는 경우 원본 문자열 반환
              return {
                korean: location,
                number: 0
              };
            };

            const parsedA = parseLocation(a);
            const parsedB = parseLocation(b);

            // 먼저 한글 부분으로 정렬
            const koreanCompare = parsedA.korean.localeCompare(parsedB.korean, 'ko-KR');

            if (koreanCompare !== 0) {
              return koreanCompare;
            }

            // 한글이 같으면 숫자로 정렬
            return parsedA.number - parsedB.number;
          });

        } else {
          throw new Error('재고위치 데이터 형식이 올바르지 않습니다.');
        }
      } catch (error) {
        console.error('재고위치 목록 로드 실패:', error);

        // API 호출 실패 시 기존 방식으로 폴백
        if (!this.inventory || this.inventory.length === 0) {
          this.locationCategories = [];
          return;
        }

        // 모든 제품의 location 값을 수집하고 중복 제거
        const locations = this.inventory
          .map(item => item.location)
          .filter(location => location && location.trim() !== '') // null, undefined, 빈 문자열 제외
          .filter((location, index, array) => array.indexOf(location) === index) // 중복 제거
          .sort((a, b) => {
            // 한글-숫자 형태의 문자열을 분리하여 정렬
            const parseLocation = (location) => {
              const match = location.match(/^([가-힣]+)-?(\d+)$/);
              if (match) {
                return {
                  korean: match[1],
                  number: parseInt(match[2], 10)
                };
              }
              // 매치되지 않는 경우 원본 문자열 반환
              return {
                korean: location,
                number: 0
              };
            };

            const parsedA = parseLocation(a);
            const parsedB = parseLocation(b);

            // 먼저 한글 부분으로 정렬
            const koreanCompare = parsedA.korean.localeCompare(parsedB.korean, 'ko-KR');

            if (koreanCompare !== 0) {
              return koreanCompare;
            }

            // 한글이 같으면 숫자로 정렬
            return parsedA.number - parsedB.number;
          });

        this.locationCategories = locations;
      }
    },

    // 특정 카테고리의 하위 카테고리 가져오기
    getSubcategoriesForCategory(categoryName) {
      const category = this.categoryTree.find(cat => cat.name === categoryName);
      if (category && category.subcategories && Array.isArray(category.subcategories)) {
        return category.subcategories;
      }
      return [];
    },

    // 하위 카테고리 선택 처리
    selectSubcategory(subCat) {
      if (this.selectedSubCategory && this.selectedSubCategory.num === subCat.num) {
        this.selectedSubCategory = null;
        this.selectedCategory = '';
      } else {
        this.selectedSubCategory = subCat;
        this.selectedCategory = subCat.name;
        this.selectedCategory1 = null;
      }

      this.currentPage = 1;
      this.fetchInventory().then(result => {
        console.log('API 응답 결과:', result);
        if (result && result.length === 0) {
          console.log('해당 서브카테고리에 대한 제품이 없습니다.');
        }
      });
      this.saveState();
    },

    // =====================================
    // 카테고리 트리 불러오기
    // =====================================
    async fetchCategoryTree() {
      try {
        const response = await this.$axios.get(`${this.$apiUrls.hanqmedi}/getAllCategories`, {
          params: { companykey: this.$globalState.company_key }
        });
        if (response.data && response.data.success) {
          this.categoryTree = response.data.data;

          // 모든 카테고리 목록 설정 (중복 제거)
          const uniqueCategories = new Map();

          // 카테고리 트리에서 고유한 카테고리 추출
          this.categoryTree.forEach(category => {
            if (!uniqueCategories.has(category.name)) {
              uniqueCategories.set(category.name, category);
            }
          });

          // Map을 배열로 변환
          this.allCategories = Array.from(uniqueCategories.values());

        }
      } catch (e) {
        console.error('카테고리 트리 불러오기 실패:', e);
      }
    },

    // 모달 닫기 메서드
    closeAlertModal() {
      this.showAlertModal = false;
      document.body.style.overflow = 'auto';
    },

    // 상세 모달 닫기
    closeDetailModal() {
      this.showModal_obj.product_detail = false;
      this.selectedItem = null;
      this.searchQuery = '';
    },

    // 상태 저장 섹션 ================================================================================
    saveState() {
      const state = {
        // 검색 관련 상태
        searchQuery: this.searchQuery,

        // 카테고리 필터 상태
        selectedCategory: this.selectedCategory,
        selectedSubCategory: this.selectedSubCategory,
        selectedMainTab: this.selectedMainTab,
        selectedLocationCategory: this.selectedLocationCategory,
        selectedStatus: this.selectedStatus,
        categoryType: this.categoryType,
        selectedSection: this.selectedSection,

        // 페이지네이션 상태
        currentPage: this.currentPage,

        // 안전재고 관련 상태
        selectedSafetyStock: this.selectedSafetyStock,
        inputSafetyStock: this.inputSafetyStock,
        safetyStockCurrentPage: this.safetyStockCurrentPage,

        // 모달 상태
        showModal_obj: {
          product_detail: this.showModal_obj.product_detail,
          product_new: this.showModal_obj.product_new,
          excel_upload: this.showModal_obj.excel_upload
        },

        // 바코드 스캔 관련 상태
        showQRCodeModal: this.showQRCodeModal,
        currentScannedLocation: this.currentScannedLocation,

        // 선택된 아이템 (모달에 표시되는 아이템)
        selectedItemId: this.selectedItem ? this.selectedItem.num : null,

        // 마지막 방문 시간 저장
        lastVisit: new Date().getTime()
      };

      localStorage.setItem('productListState', JSON.stringify(state));

      // 새로고침 감지를 위한 세션 스토리지 설정
      sessionStorage.setItem('productListVisited', 'true');
    },

    // 상태 복원 메서드 추가
    async restoreState() {
      const isRefresh = sessionStorage.getItem('productListVisited') === 'true';

      // 새로고침인 경우 상태를 복원하지 않고 초기화
      if (isRefresh) {
        localStorage.removeItem('productListState');
        sessionStorage.removeItem('productListVisited');
        return;
      }

      const savedState = localStorage.getItem('productListState');
      if (!savedState) return;

      try {
        const state = JSON.parse(savedState);

        // 검색 관련 상태 복원
        this.searchQuery = state.searchQuery || '';

        // 카테고리 필터 상태 복원
        this.selectedCategory = state.selectedCategory || '';
        this.selectedSubCategory = state.selectedSubCategory || null;
        this.selectedMainTab = state.selectedMainTab || 'purchase';
        this.selectedLocationCategory = state.selectedLocationCategory || '';
        this.selectedStatus = state.selectedStatus || '';
        this.categoryType = state.categoryType || '';
        this.selectedSection = state.selectedSection || '';

        // 페이지네이션 상태 복원
        this.currentPage = state.currentPage || 1;

        // 안전재고 관련 상태 복원
        this.selectedSafetyStock = state.selectedSafetyStock || '00';
        this.inputSafetyStock = state.inputSafetyStock || '';
        this.safetyStockCurrentPage = state.safetyStockCurrentPage || 1;

        if (state.currentScannedLocation) {
          this.currentScannedLocation = state.currentScannedLocation;
        }

        // 데이터 로드
        await this.fetchInventory();
        await this.getSafetyStock();

        // 모달 상태 복원
        if (state.showModal_obj) {
          // 모달 상태 복원
          this.showModal_obj.product_new = state.showModal_obj.product_new || false;
          this.showModal_obj.excel_upload = state.showModal_obj.excel_upload || false;
          this.showQRCodeModal = state.showQRCodeModal || false;

          // 상세 모달 및 선택된 아이템 복원
          if (state.showModal_obj.product_detail && state.selectedItemId) {
            // 선택된 아이템 찾기
            const item = this.inventory.find(item => item.num === state.selectedItemId);
            if (item) {
              this.selectedItem = item;
              this.showModal_obj.product_detail = true;
            }
          }
        }

        console.log('제품 목록 페이지 상태 복원됨');
      } catch (error) {
        console.error('상태 복원 중 오류 발생:', error);
        localStorage.removeItem('productListState');
      }
    },
    // 상태 저장 섹션 ================================================================================

    // 안전재고 검색 기능
    filterSafetyStockBySearch() {
      // 검색어가 있을 경우에만 필터링
      const searchQuery = this.inputSafetyStock.toLowerCase().trim();

      if (this.selectedSafetyStock === '00') {
        // 전체 카테고리에서 검색
        this.filteredSafetyStockItems = this.allSafetyStockItems.filter(item =>
          !searchQuery ||
          (item.name && item.name.toLowerCase().includes(searchQuery))
        );
      } else {
        // 특정 카테고리에서 검색
        this.filteredSafetyStockItems = this.allSafetyStockItems.filter(item =>
          item.name0 === this.selectedSafetyStock &&
          (!searchQuery || (item.name && item.name.toLowerCase().includes(searchQuery)))
        );
      }

      // 필터링 후 페이지네이션 정보 업데이트
      this.safetyStockTotalItems = this.filteredSafetyStockItems.length;
      this.safetyStockTotalPages = Math.ceil(this.safetyStockTotalItems / this.safetyStockItemsPerPage);
      this.safetyStockCurrentPage = 1; // 페이지 초기화
      this.updateSafetyStockItems();
      this.saveState();
    },

    // 현재 페이지에 표시할 안전재고 아이템 업데이트
    updateSafetyStockItems() {
      if (!this.filteredSafetyStockItems || !Array.isArray(this.filteredSafetyStockItems)) {
        console.error('filteredSafetyStockItems가 배열이 아니거나 정의되지 않았습니다:', this.filteredSafetyStockItems);
        this.safetyStockItems = [];
        return;
      }

      const startIndex = (this.safetyStockCurrentPage - 1) * this.safetyStockItemsPerPage;
      const endIndex = startIndex + this.safetyStockItemsPerPage;
      this.safetyStockItems = this.filteredSafetyStockItems.slice(startIndex, endIndex);
      this.saveState();
    },

    // 모든 안전재고 한번에 수정 메소드
    async updateAllSafetyStock() {
      event.stopPropagation();

      try {
        // 현재 보이는 아이템들의 목록을 가져옴
        const safetyItems = [...this.filteredSafetyStockItems];
        if (safetyItems.length === 0) {
          this.$swal.fire({
            icon: 'info',
            title: '정보',
            text: '수정할 안전재고 항목이 없습니다.'
          });
          return;
        }

        // 아이템 목록으로 HTML 테이블 생성
        let tableHtml = `
          <div style="max-height: 400px; overflow-y: auto; margin-bottom: 20px;">
            <table class="swal2-table" style="width: 100%; border-collapse: collapse;">
              <thead>
                <tr>
                  <th style="padding: 6px; border-bottom: 1px solid #ddd; text-align: left; width: 40%;">품목명</th>
                  <th style="padding: 6px; border-bottom: 1px solid #ddd; text-align: center;">색상</th>
                  <th style="padding: 6px; border-bottom: 1px solid #ddd; text-align: center;">사이즈</th>
                  <th style="padding: 6px; border-bottom: 1px solid #ddd; text-align: center;">현재 재고</th>
                  <th style="padding: 6px; border-bottom: 1px solid #ddd; text-align: center;">안전재고</th>
                </tr>
              </thead>
              <tbody>
        `;

        // 각 아이템마다 행 추가
        safetyItems.forEach((item) => {
          tableHtml += `
            <tr>
              <td style="padding: 6px; border-bottom: 1px solid #eee; text-align: left;">${item.name || ''}</td>
              <td style="padding: 6px; border-bottom: 1px solid #eee; text-align: center;">${item.color || ''}</td>
              <td style="padding: 6px; border-bottom: 1px solid #eee; text-align: center;">${item.size || ''}</td>
              <td style="padding: 6px; border-bottom: 1px solid #eee; text-align: center;">${item.quantity || 0}</td>
              <td style="padding: 6px; border-bottom: 1px solid #eee; text-align: center;">
                <input 
                  type="number" 
                  id="safety_${item.num}" 
                  class="swal2-input" 
                  style="margin: 0; width: 80px; height: 32px;" 
                  value="${item.safety || 0}" 
                  min="0"
                />
              </td>
            </tr>
          `;
        });

        tableHtml += `
              </tbody>
            </table>
          </div>
        `;

        const result = await this.$swal.fire({
          title: '안전재고 일괄 수정',
          html: tableHtml,
          showCancelButton: true,
          confirmButtonText: '일괄 수정',
          cancelButtonText: '취소',
          width: '1000px',
          preConfirm: () => {
            // 각 항목의 안전재고 값을 수집
            return safetyItems.map(item => {
              const safetyInput = document.getElementById(`safety_${item.num}`);
              const safetyValue = parseInt(safetyInput.value, 10);

              return {
                itemId: item.num,
                safetyStock: safetyValue >= 0 ? safetyValue : 0,
                originalSafety: item.safety
              };
            }).filter(item => item.safetyStock !== item.originalSafety); // 변경된 항목만 필터링
          }
        });

        if (result.isConfirmed && result.value.length > 0) {
          // 로딩 표시
          this.$swal.fire({
            title: '저장 중...',
            allowOutsideClick: false,
            didOpen: () => {
              this.$swal.showLoading();
            }
          });

          // 변경된 항목들에 대해 API 호출
          const updatePromises = result.value.map(item =>
            this.$axios.post(`${this.$apiUrls.hanqmedi}/updateSafetyStock`, {
              itemId: item.itemId,
              safetyStock: item.safetyStock,
              companykey: this.$globalState.company_key
            })
          );

          const updateResults = await Promise.all(updatePromises);

          const allSuccess = updateResults.every(res => res.data && res.data.success);

          if (allSuccess) {
            await this.$swal.fire({
              icon: 'success',
              title: '저장 완료',
              text: `${result.value.length}개 품목의 안전재고수량이 업데이트되었습니다.`,
              timer: 2000,
              showConfirmButton: false
            });

            await this.getSafetyStock();
          } else {
            throw new Error('일부 항목의 업데이트에 실패했습니다.');
          }
        }
      } catch (error) {
        console.error('안전재고 일괄 수정 오류:', error);
        this.$swal.fire({
          icon: 'error',
          title: '오류 발생',
          text: error.message || '안전재고 수량 일괄 업데이트 중 오류가 발생했습니다.',
          confirmButtonText: '확인'
        });
      }
    },

    // 안전재고 수정 메서드
    async updateSafetyStock(item) {
      // 이벤트 전파 중단
      event.stopPropagation();

      // 선택한 아이템 정보 저장
      this.selectedItem = item;

      try {
        const { value: safetyStock } = await this.$swal.fire({
          title: '안전재고 수량 수정',
          html: `
            <div>
              <p><strong>품목명:</strong> ${item.name || ''}</p>
              <p><strong>현재 재고:</strong> ${item.quantity || 0}</p>
              <p><strong>현재 안전재고:</strong> ${item.safety || 0}</p>
            </div>
            <div>
              <p><strong>수정할 안전재고수량을 입력해주세요.</strong></p>
            </div>
          `,
          input: 'number',
          inputValue: item.safety || 0,
          inputAttributes: {
            min: '0',
            step: '1'
          },
          showCancelButton: true,
          confirmButtonText: '저장',
          cancelButtonText: '취소',
          inputValidator: (value) => {
            if (!value) {
              return '수량을 입력해주세요!';
            }
            if (parseInt(value) < 0) {
              return '0 이상의 값을 입력해주세요!';
            }
          }
        });

        // 사용자가 취소를 누르거나 입력값이 없는 경우
        if (!safetyStock) return;

        const response = await this.$axios.post(`${this.$apiUrls.hanqmedi}/updateSafetyStock`, {
          itemId: item.num,
          safetyStock: parseInt(safetyStock),
          companykey: this.$globalState.company_key
        });

        if (response.data && response.data.success) {
          await this.$swal.fire({
            icon: 'success',
            title: '수정 완료',
            text: '안전재고 수량이 성공적으로 업데이트되었습니다.',
            timer: 1500,
            showConfirmButton: false
          });

          await this.getSafetyStock();
        } else {
          throw new Error(response.data?.message || '안전재고 수량 업데이트에 실패했습니다.');
        }
      } catch (error) {
        console.error('안전재고 수량 업데이트 오류:', error);

        this.$swal.fire({
          icon: 'error',
          title: '오류 발생',
          text: error.message || '안전재고 수량 업데이트 중 오류가 발생했습니다.',
          confirmButtonText: '확인'
        });
      }
    },

    async getSafetyStock() {
      this.safetyStockLoading = true;

      try {
        const token = localStorage.getItem('token');
        if (!token) {
          throw new Error('인증 토큰이 없습니다.');
        }

        const response = await this.$axios.get(`${this.$apiUrls.hanqmedi}/getSafetyStock`, {
          params: {
            companykey: this.$globalState.company_key,
            includeLinkedCompanies: true // 연결된 사업소의 안전재고 포함
          },
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        // 안전재고 전체 데이터
        if (response.data.success) {
          this.allSafetyStockItems = response.data.items.map(item => ({
            num: item.num,
            name0: item.name0 || '',       // 카테고리
            name: item.name3 || item.name, // 품목명
            name4: item.name4 || '',       // 모델명
            code: item.code || '',         // 품목코드
            bcode: item.bcode || '',       // 바코드
            color: item.color || '',       // 색상
            size: item.size || '',         // 사이즈
            quantity: item.quantity || 0,  // 재고수량
            target: item.target || 0,      // 구입,대여
            company: item.company || '',   // 거래처명
            tax: item.tax || '과세',            // 부가세
            price: item.price || 0,        // 판매가
            price2: item.price2 || 0,      // 대여가
            price3: item.price3 || 0,      // 공급가
            note: item.note || '',         // 비고
            icode: item.icode || '',       // 보험코드
            location: item.location || '', // 위치
            safety: item.safety || 0       // 안전재고수량
          }));

          // 선택된 카테고리에 따라 필터링
          this.filterSafetyStockByCategory();
        } else {
          console.error('안전재고 데이터 가져오기 실패:', response.data.message);
          this.allSafetyStockItems = [];
          this.filteredSafetyStockItems = [];
          this.safetyStockItems = [];
          this.safetyStockTotalPages = 1;
          this.safetyStockTotalItems = 0;
        }
        this.saveState();
      } catch (error) {
        console.error('안전재고 데이터 조회 중 오류 발생:', error);

        if (error.response && error.response.status === 401) {
          // 토큰이 유효하지 않은 경우
          localStorage.removeItem('token');
          localStorage.removeItem('userInfo');
          this.$router.push('/login');
          return;
        }

        this.allSafetyStockItems = [];
        this.filteredSafetyStockItems = [];
        this.safetyStockItems = [];
        this.safetyStockTotalPages = 1;
        this.safetyStockTotalItems = 0;

        await this.$swal.fire({
          icon: 'error',
          title: '오류 발생',
          text: '안전재고 데이터를 불러오는 중 오류가 발생했습니다.',
          confirmButtonText: '확인'
        });
      } finally {
        this.safetyStockLoading = false;
      }
    },

    // 안전재고 카테고리 필터 기능
    filterSafetyStockByCategory() {
      // 선택된 카테고리에 따라 필터링
      if (this.selectedSafetyStock === '00') {
        // '전체' 선택 시 모든 데이터 표시 (수량 3개 이하만)
        this.filteredSafetyStockItems = [...this.allSafetyStockItems];
      } else {
        // 특정 카테고리 선택 시 해당 카테고리만 필터링
        this.filteredSafetyStockItems = this.allSafetyStockItems.filter(item =>
          item.name0 === this.selectedSafetyStock
        );
      }

      // 필터링 후 페이지네이션 정보 업데이트
      this.safetyStockTotalItems = this.filteredSafetyStockItems.length;
      this.safetyStockTotalPages = Math.ceil(this.safetyStockTotalItems / this.safetyStockItemsPerPage);
      this.safetyStockCurrentPage = 1; // 페이지 초기화
      this.updateSafetyStockItems();
      this.filterSafetyStockBySearch();
      this.saveState();
    },

    // 안전재고 검색 기능
    searchSafetyStock() {
      this.safetyStockCurrentPage = 1;
      this.filterSafetyStockByCategory();

      // 검색 결과가 없는 경우 SweetAlert 표시
      if (this.filteredSafetyStockItems.length === 0) {
        this.$swal.fire({
          title: '검색 결과 없음',
          text: '검색 조건에 맞는 안전재고 항목이 없습니다.',
          icon: 'info',
          confirmButtonText: '확인'
        });
      }
      this.saveState();
    },

    // 안전재고 페이지네이션 메서드
    async changeSafetyStockPage(newPage) {
      if (newPage < 1 || newPage > this.safetyStockTotalPages) return;
      this.safetyStockCurrentPage = newPage;
      this.updateSafetyStockItems();
      this.saveState();
    },

    async goToSafetyStockPage(pageNum) {
      if (pageNum !== this.safetyStockCurrentPage && pageNum > 0 && pageNum <= this.safetyStockTotalPages) {
        this.safetyStockCurrentPage = pageNum;
        await this.getSafetyStock();
        this.saveState();
      }
    },

    async goToSafetyStockPageGroup(direction) {
      const currentGroup = Math.floor((this.safetyStockCurrentPage - 1) / 10);
      let newPage;

      if (direction === 'prev') {
        // 이전 그룹의 첫 페이지로
        newPage = Math.max(1, (currentGroup - 1) * 10 + 1);
      } else {
        // 다음 그룹의 첫 페이지로
        newPage = Math.min(this.safetyStockTotalPages, (currentGroup + 1) * 10 + 1);
      }

      if (newPage !== this.safetyStockCurrentPage) {
        this.safetyStockCurrentPage = newPage;
        await this.getSafetyStock();
        this.saveState();
      }
    },

    // ------------------- 품목 메서드 ------------------- //
    // 재고 입고
    async stockIn(item, quantity) {
      const response = await this.$axios.post(`${this.$apiUrls.hanqmedi}/stockIn`, {
        "b_item_id": item.num,
        "quantity": quantity,
        "companykey": this.$globalState.company_key,
        "size": "",
        "color": ""
      });
      console.log("입고 응답:", response.data)
    },
    decreaseQuantity(item) {
      if (item.quantity > 0) {
        item.quantity--;
        this.updateQuantity(item);
      }
    },
    increaseQuantity(item) {
      item.quantity++;
      this.stockIn(item, item.quantity);
      this.updateQuantity(item);
    },
    async updateQuantity(item) {
      try {
        const response = await this.$axios.post(`${this.$apiUrls.hanqmedi}/updateProductQuantity`, {
          num: item.num,
          quantity: item.quantity
        });
        console.log('수량 업데이트 성공:', response.data);
      } catch (error) {
        console.error('수량 업데이트 실패:', error);
        // 오류 발생 시 원래 수량으로 되돌리기
        this.fetchInventory();
      }
    },

    // 이미지 경로 가져오기
    getImageUrl(item) {
      if (!item || !item.num) {
        return '/icon.png';
      }

      const s3BaseUrl = this.$apiUrls.s3Bucket;
      const timestamp = this.imageUpdateKey;

      // S3 버킷에서만 시도 - 먼저 item.num으로 시도
      return `${s3BaseUrl}/Product-image/${item.num}.jpg?t=${timestamp}`;
    },

    // 이미지 로드 에러 처리
    handleImageError(e) {
      const currentSrc = e.target.src;
      const item = JSON.parse(e.target.dataset.item);
      const s3BaseUrl = this.$apiUrls.s3Bucket;

      // 기본 이미지로 이미 변경된 경우, 더 이상 시도하지 않음
      if (currentSrc.includes('/icon.png')) {
        console.log('기본 이미지 로드 완료');
        return;
      }

      const extensions = ['jpg', 'jpeg', 'png'];
      const urlParts = currentSrc.split('/');
      const fileNameWithExt = urlParts[urlParts.length - 1];
      const fileNamePart = fileNameWithExt.split('.')[0].split('?')[0];
      const currentExt = fileNameWithExt.split('.')[1]?.split('?')[0];

      const isUsingNum = String(fileNamePart) === String(item.num);

      if (!isUsingNum) {
        // num이 아닌 다른 값으로 시도 중이면 num으로 변경
        const timestamp = this.imageUpdateKey;
        e.target.src = `${s3BaseUrl}/Product-image/${item.num}.${extensions[0]}?t=${timestamp}`;
        return;
      }

      // 현재 확장자의 인덱스를 찾음
      const currentExtIndex = extensions.indexOf(currentExt);
      const nextExtIndex = currentExtIndex + 1;

      if (nextExtIndex < extensions.length) {
        // 다음 확장자 시도
        const timestamp = this.imageUpdateKey;
        e.target.src = `${s3BaseUrl}/Product-image/${item.num}.${extensions[nextExtIndex]}?t=${timestamp}`;
      } else {
        // 모든 확장자를 시도했지만 실패 → 기본 이미지로 설정
        e.target.src = '/icon.png';
      }
    },

    async handleItemUpdated(updatedItem) {
      try {
        // 이미지 강제 새로고침을 위한 키 업데이트
        if (updatedItem.imageUpdateTime) {
          this.imageUpdateKey = updatedItem.imageUpdateTime;

          // 이미지 업데이트인 경우 전체 목록 새로고침 하지 않음
          const index = this.inventory.findIndex(item => item.num === updatedItem.num);
          if (index !== -1) {
            // 현재 아이템의 이미지 관련 상태만 업데이트
            this.inventory[index] = {
              ...this.inventory[index],
              imageUpdateTime: updatedItem.imageUpdateTime
            };

            // 강제 리렌더링
            this.$forceUpdate();
            return; // 이미지 업데이트의 경우 여기서 종료
          }
        }

        // 이미지 외 다른 정보 업데이트의 경우
        const index = this.inventory.findIndex(item => item.num === updatedItem.num);
        if (index !== -1) {
          this.inventory[index] = {
            ...updatedItem,
            bcode: updatedItem.options?.bcode?.[0] || '',
            status: updatedItem.status || '',
            icode: updatedItem.icode || '',
            price: updatedItem.price ? updatedItem.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0',
            note: updatedItem.options?.note?.[0] || '',
            color: updatedItem.options?.color?.[0] || '',
            size: updatedItem.options?.size?.[0] || '',
            quantity: updatedItem.quantity || '0'
          };
        }

        // selectedItem 업데이트 (모달에 표시되는 아이템)
        if (this.selectedItem && this.selectedItem.num === updatedItem.num) {
          this.selectedItem = { ...updatedItem };
        }

        // 이미지 업데이트가 아닌 경우에만 전체 목록 새로고침
        if (!updatedItem.imageUpdateTime) {
          await this.fetchInventory();
        }

      } catch (error) {
        console.error('품목 업데이트 처리 중 오류:', error);
        await this.$swal.fire({
          title: '오류',
          text: '품목 업데이트 처리 중 오류가 발생했습니다.',
          icon: 'error',
          confirmButtonText: '확인'
        });
      }
    },
    async searchProducts() {
      this.currentPage = 1;

      try {
        const results = await this.fetchInventory();

        // 검색어가 있고 결과가 없는 경우 메시지 표시
        if (this.searchQuery && (!results || results.length === 0)) {
          this.$swal.fire({
            title: '검색 결과 없음',
            text: `'${this.searchQuery}'에 대한 검색 결과를 찾을 수 없습니다.`,
            icon: 'info',
            confirmButtonText: '확인',
            confirmButtonColor: '#3085d6'
          });
        }
        this.saveState();
      } catch (error) {
        console.error('searchProducts 에러 발생:', error);

        this.$swal.fire({
          title: '검색 오류',
          text: '검색 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.',
          icon: 'error',
          confirmButtonText: '확인',
          confirmButtonColor: '#d33'
        });
      }
    },
    resetNewProduct() {
      this.newProduct = {
        name: '',
        name2: '',
        size: '',
        color: '',
        option: '',
        target: '',
        bcode: '',
        code: '',
        price: '',
        quantity: '',
        note: '',
        company: '',
        tax: '',
        companykey: this.$globalState.company_key
      };
    },

    async handleProductDeleted(productId) {
      try {
        // 현재 표시된 데이터에서 삭제된 항목 제거
        this.inventory = this.inventory.filter(item => item.num !== productId);

        // 전체 데이터 다시 불러오기
        await this.fetchInventory();

        // 현재 페이지에 아이템이 없는 경우 이전 페이지로 이동
        if (this.inventory.length === 0 && this.currentPage > 1) {
          this.currentPage--;
          await this.fetchInventory(); // 페이지 변경 후 다시 데이터 로드
        }

      } catch (error) {
        console.error('품목 삭제 처리 중 오류:', error);
      }
    },

    // ------------------- 엑셀 메서드 ------------------- //
    async handleExcelUpload(event) {
      const file = event.target.files[0];
      if (!file) return;

      // 파일 확장자 체크
      const fileExt = file.name.split('.').pop().toLowerCase();
      if (fileExt !== 'xlsx') {
        this.$swal.fire('오류', 'Excel 파일(.xlsx)만 업로드 가능합니다.', 'error');
        return;
      }

      // companykey 확인
      if (!this.$globalState.company_key) {
        this.$swal.fire('오류', '회사 정보가 없습니다. 다시 로그인해주세요.', 'error');
        return;
      }

      try {
        // 로딩 표시
        const loading = this.$swal.fire({
          title: '엑셀 업로드 중...',
          text: '잠시만 기다려주세요.',
          allowOutsideClick: false,
          didOpen: () => {
            this.$swal.showLoading();
          }
        });

        let response;

        // 일렉트론 환경에서 IPC 파일 업로드 사용
        if (this.$env.isElectron) {

          // 파일을 base64로 변환
          const base64Data = await this.fileToBase64(file);

          // 데이터 구조 수정 - fileData를 직접 전달
          const formData = {
            fileName: file.name,
            fileData: base64Data,
            companykey: this.$globalState.company_key
          };

          // 토큰을 config로 전달
          const config = {
            token: localStorage.getItem('token')
          };

          // IPC를 통한 파일 업로드
          const uploadResult = await window.electronAPI.uploadFile('stock', formData, config);

          if (uploadResult.success) {
            response = { data: uploadResult.data };
          } else {
            throw new Error(uploadResult.error || '파일 업로드 실패');
          }

        } else {
          // 웹 환경에서 FormData 사용 (기존 방식)
          console.log(' 웹 환경에서 FormData 업로드');

          const formData = new FormData();
          formData.append('stock', file);
          formData.append('companykey', this.$globalState.company_key);

          const directAxios = (await import('axios')).default;

          response = await directAxios.post(
            `${this.$apiUrls.hanqmedi}/uploadStockExcel`,
            formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
              },
              timeout: 300000,
              maxContentLength: 100 * 1024 * 1024
            }
          );
        }

        loading.close();

        console.log('✅ 엑셀 업로드 성공:', response.data);

        // 상세 결과 정보 구성
        const result = response.data.data;
        const totalRows = result.rowsProcessed + result.rowsFailed;

        let resultHtml = `
          <div style="text-align: center; margin-bottom: 15px;">
            <h4 style="color: #28a745; margin-bottom: 10px;">📊 처리 결과</h4>
            <p><strong>총 처리 건수:</strong> ${totalRows}건</p>
            <p><strong>성공:</strong> <span style="color: #28a745;">${result.rowsProcessed}건</span></p>
            <p><strong>실패:</strong> <span style="color: #dc3545;">${result.rowsFailed}건</span></p>
          </div>
        `;

        // 실패한 행이 있는 경우 상세 정보 표시
        if (result.rowsFailed > 0 && result.failedRows && result.failedRows.length > 0) {
          resultHtml += `
            <div style="text-align: center; margin-top: 15px;">
              <h5 style="color: #dc3545; margin-bottom: 10px;">❌ 실패한 행 상세정보</h5>
              <div style="max-height: 200px; overflow-y: auto; background: #f8f9fa; padding: 10px; border-radius: 5px; font-size: 12px;">
          `;

          result.failedRows.forEach(({ rowIndex, error, data }) => {
            resultHtml += `
              <div style="margin-bottom: 8px; padding: 5px; border-left: 3px solid #dc3545; background: white;">
                <strong>${rowIndex}번 행:</strong> ${error}<br>
                <small style="color: #6c757d;">데이터: ${JSON.stringify(data)}</small>
              </div>
            `;
          });

          resultHtml += `
              </div>
            </div>
          `;
        }

        this.$swal.fire({
          title: '업로드 완료',
          html: resultHtml,
          icon: 'success',
          width: '600px',
          confirmButtonText: '확인',
          showCloseButton: true
        });

        // 목록 새로고침
        this.fetchInventory();

      } catch (error) {
        console.error('엑셀 업로드 오류:', error);

        // 더 자세한 에러 정보 로깅
        if (error.response) {
          console.error('서버 응답 상세:', {
            status: error.response.status,
            statusText: error.response.statusText,
            data: error.response.data,
            headers: error.response.headers
          });
        }

        let errorMessage = '엑셀 업로드 중 오류가 발생했습니다.';

        if (error.response) {
          switch (error.response.status) {
            case 400:
              errorMessage = error.response.data.message || '잘못된 요청입니다.';
              if (error.response.data.debug) {
                console.error('디버그 정보:', error.response.data.debug);
              }
              break;
            case 401:
              errorMessage = '인증이 필요합니다. 다시 로그인해주세요.';
              break;
            case 413:
              errorMessage = '파일 크기가 너무 큽니다.';
              break;
            case 500:
              errorMessage = error.response.data.message || '서버 오류가 발생했습니다. 잠시 후 다시 시도해주세요.';
              break;
            default:
              errorMessage = `서버 오류 (${error.response.status}): ${error.response.data.message || error.response.statusText}`;
          }
        } else if (error.code === 'ECONNABORTED') {
          errorMessage = '업로드 시간이 초과되었습니다. 네트워크 상태를 확인해주세요.';
        } else if (error.message) {
          errorMessage = error.message;
        }

        this.$swal.fire({
          title: '업로드 실패',
          text: errorMessage,
          icon: 'error',
          confirmButtonText: '확인'
        });
      }
    },

    // 파일을 Base64로 변환하는 헬퍼 메서드
    fileToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    },

    // 파일을 Base64로 변환하는 헬퍼 메서드
    fileToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    },

    // 파일 크기 포맷팅 헬퍼 메서드
    formatFileSize(bytes) {
      if (bytes === 0) return '0 Bytes';
      const k = 1024;
      const sizes = ['Bytes', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    },

    // ------------------- 엑셀 템플릿 다운로드 ------------------- //
    async downloadExcelTemplate() {
      try {
        // 로딩 표시
        const loading = this.$swal.fire({
          title: '템플릿 다운로드 중...',
          text: '잠시만 기다려주세요.',
          allowOutsideClick: false,
          didOpen: () => {
            this.$swal.showLoading();
          }
        });

        let response;

        // 일렉트론 환경에서 안정적인 다운로드 처리
        if (this.$env.isElectron) {
          try {
            // 방법 1: IPC를 통한 다운로드 (권장)
            if (window.electronAPI && window.electronAPI.downloadFile) {
              const result = await window.electronAPI.downloadFile(
                `${this.$apiUrls.hanqmedi}/downloadStockExcelTemplate`,
                '의료기 재고 템플릿.xlsx'
              );

              if (result.success) {
                loading.close();
                this.$swal.fire({
                  title: '다운로드 완료',
                  text: '엑셀 템플릿이 다운로드 폴더에 저장되었습니다.',
                  icon: 'success',
                  timer: 3000,
                  showConfirmButton: false
                });
                return;
              } else {
                throw new Error(result.error || '다운로드 실패');
              }
            }
          } catch (ipcError) {
            console.warn('IPC 다운로드 실패, 직접 axios 사용:', ipcError);
          }

          // 방법 2: 직접 axios 사용 (fallback)
          const directAxios = (await import('axios')).default;

          response = await directAxios.get(
            `${this.$apiUrls.hanqmedi}/downloadStockExcelTemplate`,
            {
              responseType: 'blob',
              headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`,
                'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
              },
              timeout: 60000, // 60초로 증가
              maxContentLength: 50 * 1024 * 1024, // 50MB 제한
              validateStatus: (status) => status < 500 // 500 에러는 throw
            }
          );

        } else {
          // 웹 환경
          console.log('웹 환경에서 다운로드 처리');

          const directAxios = (await import('axios')).default;

          response = await directAxios.get(
            `${this.$apiUrls.hanqmedi}/downloadStockExcelTemplate`,
            {
              responseType: 'blob',
              headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
              },
              timeout: 30000
            }
          );
        }

        loading.close();

        // 응답 데이터 검증
        if (!response.data || response.data.size === 0) {
          throw new Error('다운로드된 파일이 비어있습니다.');
        }

        console.log('📦 다운로드된 파일 정보:', {
          size: this.formatFileSize(response.data.size),
          type: response.data.type
        });

        // 파일 다운로드 처리
        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });

        // 파일명 설정 (한글 파일명 처리)
        const fileName = '의료기 재고 템플릿.xlsx';

        // 일렉트론 환경에서 다운로드 처리
        if (this.$env.isElectron) {
          try {
            // 일렉트론의 다운로드 API 사용
            if (window.electronAPI && window.electronAPI.saveFile) {
              const base64Data = await this.blobToBase64(blob);
              const result = await window.electronAPI.saveFile(fileName, base64Data);

              if (result.success) {
                this.$swal.fire({
                  title: '다운로드 완료',
                  text: `파일이 저장되었습니다: ${result.filePath}`,
                  icon: 'success',
                  timer: 3000,
                  showConfirmButton: false
                });
                return;
              }
            }
          } catch (saveError) {
            console.warn('일렉트론 저장 실패, 브라우저 다운로드 사용:', saveError);
          }
        }

        // 브라우저 다운로드 (fallback)
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        link.style.display = 'none';

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // 메모리 정리
        setTimeout(() => {
          window.URL.revokeObjectURL(url);
        }, 1000);

        this.$swal.fire({
          title: '다운로드 완료',
          text: '엑셀 템플릿이 성공적으로 다운로드되었습니다.',
          icon: 'success',
          timer: 2000,
          showConfirmButton: false
        });

      } catch (error) {
        console.error('템플릿 다운로드 오류:', error);

        // 더 자세한 에러 정보 로깅
        if (error.response) {
          console.error('서버 응답 상세:', {
            status: error.response.status,
            statusText: error.response.statusText,
            headers: error.response.headers,
            data: error.response.data
          });
        }

        let errorMessage = '엑셀 템플릿 다운로드 중 오류가 발생했습니다.';

        if (error.response) {
          switch (error.response.status) {
            case 401:
              errorMessage = '인증이 필요합니다. 다시 로그인해주세요.';
              break;
            case 403:
              errorMessage = '템플릿 다운로드 권한이 없습니다.';
              break;
            case 404:
              errorMessage = '템플릿 파일을 찾을 수 없습니다.';
              break;
            case 500:
              errorMessage = '서버에서 템플릿 생성 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.';
              break;
            default:
              errorMessage = `서버 오류 (${error.response.status}): ${error.response.statusText}`;
          }
        } else if (error.code === 'ECONNABORTED') {
          errorMessage = '다운로드 시간이 초과되었습니다. 네트워크 상태를 확인해주세요.';
        } else if (error.message) {
          errorMessage = error.message;
        }

        this.$swal.fire({
          title: '다운로드 실패',
          text: errorMessage,
          icon: 'error',
          confirmButtonText: '확인'
        });
      }
    },

    // Blob을 Base64로 변환하는 헬퍼 메서드
    blobToBase64(blob) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    },

    // ------------------- 모달 메서드 ------------------- //
    openNewModal() {
      this.showModal_obj.product_new = true;
      this.saveState();
    },
    closeModal() {
      this.showModal = false;
      this.selectedItem = null;
      this.scannedBarcode = '';
      this.qrCodeUrl = null;
      this.saveState();
    },
    openQRCodeModal() {
      this.showQRCodeModal = true;
      this.saveState();
    },
    openLocationPrintModal() {
      if (this.isBarcodeScanning) {
        this.stopBarcodeScanning();
      }
      document.body.style.overflow = 'hidden';
      this.showLocationPrintModal = true;
      this.saveState();
    },
    openLocationAddModal(location = '', barcode = '') {
      if (this.isBarcodeScanning) {
        this.stopBarcodeScanning();
      }
      document.body.style.overflow = 'hidden';
      this.targetLocationForModal = location || this.selectedLocationCategory || '전체';
      this.initialBarcodeForModal = barcode; // 바코드 정보 저장
      this.showLocationAddModal = true;
      this.saveState();
    },
    closeQRCodeModal() {
      this.showQRCodeModal = false;
      this.saveState();
    },
    closeLocationPrintModal() {
      this.showLocationPrintModal = false;
      document.body.style.overflow = 'auto';
      this.saveState();
    },
    closeLocationAddModal() {
      this.showLocationAddModal = false;
      this.initialBarcodeForModal = ''; // 바코드 정보 초기화
      document.body.style.overflow = 'auto';
      this.saveState();
    },
    async openDetailModal(item) {
      console.log('openDetailModal', item);
      if (this.isBarcodeScanning) {
        this.stopBarcodeScanning();
      }

      // 안전재고 아이템인 경우 (safetyStockItems에서 호출된 경우)
      if (item.name && !item.name3) {
        const transformedItem = {
          ...item,
          name0: item.name0 || '',
          name3: item.name,
          name4: item.name4,
          code: item.code || '',
          target: item.target || '구입',
          options: {
            bcode: [item.code || ''],
            color: [item.color || ''],
            size: [item.size || ''],
            note: ['']
          },
          price: item.price || 0,     // 판매가
          price2: item.price2 || 0,   // 대여가
          price3: item.price || 0,    // 공급가
          quantity: item.quantity || 0,
          company: item.company || '',
          icode: item.icode || '',
          location: item.location || '',
          tax: item.tax || '과세',
        };
        this.selectedItem = transformedItem;
      } else {
        // 일반 재고 아이템인 경우
        this.selectedItem = item;
      }

      this.showModal_obj.product_detail = true;
      this.saveState();
    },

    // ------------------- 기타 메서드 ------------------- //
    async fetchInventory() {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          this.$router.push('/login');
          return;
        }

        let categoryName = '';
        let subcategoryName = '';
        let location = '';

        // 의료기 카테고리 설정
        if (this.selectedCategory1) {
          categoryName = this.selectedCategory1.name;
        } else if (this.selectedSubCategory) {
          // 보조기기의 서브카테고리인 경우
          categoryName = '보조기기';
          subcategoryName = this.selectedSubCategory.name;
        }

        // 재고위치 설정
        if (this.selectedLocationCategory) {
          location = this.selectedLocationCategory;
        }

        // API 호출 시 카테고리와 위치를 별도 파라미터로 전달
        const response = await this.$axios.post(`${this.$apiUrls.hanqmedi}/getProducts`, {
          page: this.currentPage,
          search: this.searchQuery,
          stockSt: 0,
          status: this.selectedStatus,
          category: categoryName,
          subcategory: subcategoryName,
          location: location,
          companykey: this.$globalState.company_key
        }, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        this.inventory = Array.isArray(response.data.contentsList) ? response.data.contentsList : [];
        this.currentPage = response.data.currentPage || 1;
        this.totalPages = response.data.totalPages || 1;
        this.totalItems = response.data.totalItems || 0;
        this.pnStart = response.data.pnStart || 1;
        this.pnEnd = response.data.pnEnd || 1;

        // 재고가 없는 경우 안내 메시지 표시
        if (response.data.noData || this.inventory.length === 0) {
          let message = '해당 조건에 맞는 재고가 없습니다.';

          if (categoryName) {
            message = `'${categoryName}' 카테고리에 등록된 재고가 없습니다.`;
          }
          if (subcategoryName) {
            message = `'${categoryName} > ${subcategoryName}' 카테고리에 등록된 재고가 없습니다.`;
          }
          if (location) {
            message = `'${location}' 위치에 등록된 재고가 없습니다.`;
          }
          if (this.searchQuery) {
            message = `'${this.searchQuery}' 검색 결과가 없습니다.`;
          }

          this.$swal.fire({
            title: '재고 없음',
            text: message,
            icon: 'info',
            confirmButtonText: '확인',
            confirmButtonColor: '#3085d6'
          });
        }

        // 재고위치 카테고리 추출
        await this.extractLocationCategories();

        this.saveState();
        return this.inventory;

      } catch (error) {
        console.error('재고 데이터 불러오기 오류:', error);

        if (error.response && error.response.status === 401) {
          // 토큰이 유효하지 않은 경우
          localStorage.removeItem('token'); // 토큰 제거
          localStorage.removeItem('userInfo'); // 사용자 정보 제거
          this.$router.push('/login'); // 로그인 페이지로 리다이렉트
          return;
        }

        // 500 에러인 경우에도 적절한 메시지 표시
        if (error.response && error.response.status === 500) {
          let message = '해당 조건에 맞는 재고가 없습니다.';

          if (this.selectedCategory1?.name) {
            message = `'${this.selectedCategory1.name}' 카테고리에 등록된 재고가 없습니다.`;
          }
          if (this.selectedSubCategory?.name) {
            message = `'보조기기 > ${this.selectedSubCategory.name}' 카테고리에 등록된 재고가 없습니다.`;
          }
          if (this.selectedLocationCategory) {
            message = `'${this.selectedLocationCategory}' 위치에 등록된 재고가 없습니다.`;
          }
          if (this.searchQuery) {
            message = `'${this.searchQuery}' 검색 결과가 없습니다.`;
          }

          this.$swal.fire({
            title: '재고 없음',
            text: message,
            icon: 'info',
            confirmButtonText: '확인',
            confirmButtonColor: '#3085d6'
          });
        } else {
          this.$swal.fire({
            icon: 'error',
            title: '오류 발생',
            text: '재고 데이터를 불러오는 중 오류가 발생했습니다.',
            confirmButtonText: '확인'
          });
        }

        this.inventory = [];
        this.currentPage = 1;
        this.totalPages = 1;
        this.totalItems = 0;
        this.pnStart = 1;
        this.pnEnd = 1;

        return;
      }
    },

    showDevelopMessage() {
      this.$swal.fire({
        icon: 'info',
        title: '개발 진행중',
        text: '발주 기능은 현재 개발 중입니다.',
        confirmButtonText: '확인'
      });
    },

    goToPage(page) {
      if (page > 0 && page <= this.totalPages && page !== this.currentPage) {
        this.currentPage = page;
        this.fetchInventory();
        this.saveState();

        // 페이지 상단으로 스크롤
        window.scrollTo({
          top: 200,
        });
      }
    },
  },

  async mounted() {
    try {
      // 첫 방문 여부 확인
      const isFirstVisit = !sessionStorage.getItem('productListVisited');

      // 데이터 로드
      await Promise.all([
        this.fetchInventory(),
        this.getSafetyStock(),
        this.fetchCategoryTree(),
        this.extractLocationCategories()
      ]);

      // 첫 방문인 경우 모달 표시
      if (isFirstVisit) {
        this.showAlertModal = true;
        this.alertModalType = 'inventory';
        this.alertModalTitle = '안전재고 관리';
        sessionStorage.setItem('productListVisited', 'true');
      } else {
        // 첫 방문이 아닌 경우에만 상태 복원
        await this.restoreState();
      }
    } catch (error) {
      console.error('초기 데이터 로드 중 오류:', error);
    }
  },

  // 컴포넌트가 활성화될 때 세션 스토리지 설정
  activated() {
    sessionStorage.setItem('productListVisited', 'true');
  },

  beforeUnmount() {
    this.saveState();
    this.stopBarcodeScanning();
    // 페이지를 떠날 때 세션 스토리지 제거
    sessionStorage.removeItem('productListVisited');
  },

  // 컴포넌트가 비활성화될 때 상태 저장
  deactivated() {
    this.saveState();
  },

  watch: {
    // 상세보기 모달
    'showModal_obj.product_detail': function (newVal) {
      // 모달 상태가 변경될 때마다 body의 스크롤을 제어
      if (newVal) {
        // 모달이 열릴 때
        document.body.style.overflow = 'hidden';
        if (this.isBarcodeScanning) {
          this.stopBarcodeScanning();
        }
      } else {
        // 모달이 닫힐 때
        document.body.style.overflow = 'auto';
        this.selectedItem = null;
        this.fetchInventory();
      }
      this.saveState();
    },
    // 신규 품목 등록 모달
    'showModal_obj.product_new': function (newVal) {
      if (newVal) {
        document.body.style.overflow = 'hidden';
        if (this.isBarcodeScanning) {
          this.stopBarcodeScanning();
        }
      } else {
        document.body.style.overflow = 'auto';
      }
      this.saveState();
    },
    // 엑셀 재고등록 모달
    'showModal_obj.excel_upload': function (newVal) {
      if (newVal) {
        document.body.style.overflow = 'hidden';
        if (this.isBarcodeScanning) {
          this.stopBarcodeScanning();
        }
      } else {
        document.body.style.overflow = 'auto';
      }
      this.saveState();
    },
    // QR코드 가격표 생성 모달
    showQRCodeModal(newVal) {
      if (newVal) {
        document.body.style.overflow = 'hidden';
        if (this.isBarcodeScanning) {
          this.stopBarcodeScanning();
        }
      } else {
        document.body.style.overflow = 'auto';
      }
      this.saveState();
    },
    selectedStatus() {
      this.currentPage = 1;
      this.fetchInventory();
      this.saveState();
    },
    selectedCategory() {
      this.currentPage = 1;
      this.fetchInventory();
      this.saveState();
    },
    selectedLocationCategory() {
      this.saveState();
    },
    categoryType() {
      this.currentPage = 1;
      this.saveState();
    },
    selectedSafetyStock() {
      this.filterSafetyStockByCategory();
      this.saveState();
    },
    searchQuery() {
      this.saveState();
    },
    inputSafetyStock() {
      this.saveState();
    }
  }
};
</script>